module.exports = __webpack_public_path__ + "static/img/policyNews.68cfc7fa.jpg";